import { render, staticRenderFns } from "./IconCheckboxUnchecked.vue?vue&type=template&id=2b5b211c&"
import script from "./IconCheckboxUnchecked.vue?vue&type=script&lang=js&"
export * from "./IconCheckboxUnchecked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports